import React from 'react';
import AvatarCarouselContainer from './AvatarCarouselContainer';

export default React.memo(AvatarCarouselContainer, (prevProps, nextProps) => {
    if (prevProps.openEvent !== nextProps.openEvent) {
        return false;
    }

    if (prevProps.seasonContext?.seasonId !== nextProps.seasonContext?.seasonId) {
        return false;
    }

    const prevEvents = Object.keys(prevProps.seasonEvents);
    const nextEvents = Object.keys(nextProps.seasonEvents);
    if (prevEvents.length !== nextEvents.length) {
        return false;
    }

    // Entry references are stable store objects between fetches and are
    // replaced wholesale by any photo change, so identity sees photo-set
    // swaps that comparing event ids alone cannot.
    return prevEvents.every(eventName =>
        prevProps.seasonEvents[eventName] === nextProps.seasonEvents[eventName]
    );
});